"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Divider = _interopRequireDefault(require("../../Divider"));

var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-style-react/dist/cjs/Card/Divider/index.js",
    _this = void 0;

var Divider = function Divider(props) {
  return /*#__PURE__*/_react["default"].createElement(_Divider["default"], (0, _extends2["default"])({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 26
    }
  }));
};

Divider.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests. */
  dataHook: _propTypes["default"].string
};
Divider.displayName = 'Card.Divider';
var _default = Divider;
exports["default"] = _default;
//# sourceMappingURL=index.js.map